import { render, staticRenderFns } from "./AcademicDegrees.vue?vue&type=template&id=7bc9b05c&scoped=true&"
import script from "./AcademicDegrees.vue?vue&type=script&lang=js&"
export * from "./AcademicDegrees.vue?vue&type=script&lang=js&"
import style0 from "./AcademicDegrees.vue?vue&type=style&index=0&id=7bc9b05c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc9b05c",
  null
  
)

export default component.exports